<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">{{ inputData.TitleEn }}</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <div *ngIf="!inputData.ShowAttachments || inputData.ShowAttachments.length == 0">
                    <div class="ultimate-3d-card p-5 text-center mx-auto" style="max-width: 400px; border-radius: 24px; background: rgba(255, 255, 255, 0.85); box-shadow: 0 15px 35px rgba(13, 139, 84, 0.08);">
                        <i class="fa-regular fa-images" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                        <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Images Available</h3>
                    </div>
                </div>

                <div class="row g-4 justify-content-center" *ngIf="inputData.ShowAttachments && inputData.ShowAttachments.length > 0">
                    <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let item of inputData.ShowAttachments">
                        <div class="gallery-3d-card h-100 d-flex flex-column">
                            <div class="gallery-image-wrapper">
                                <img [src]="item.FilePath" alt="image" />
                            </div>
                            <div class="gallery-content flex-grow-1 d-flex align-items-center justify-content-center text-center" *ngIf="item.Title && item.Title !== ''">
                                <h4 class="gallery-title">{{ item.Title }}</h4>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>